import { createSlice } from '@reduxjs/toolkit';
import { FormAccordion } from '@strata/react-form-section';

import { FormSections } from 'store/checklist/referralChecklistSchema';

// Set up initial form state
const initSections = () => {
    const sections = {};
    Object.values(FormSections).forEach((section) => {
        sections[section] = {
            progressIndicatorStatus: FormAccordion.statuses.NOT_STARTED,
            isOpen: false,
        };
    });
    return sections;
};

const initialState = {
    sections: initSections(),
    activeSection: 1,
    unsavedChanges: false,
};

export const referralChecklistSlice = createSlice({
    name: 'referralChecklist',
    initialState,
    reducers: {
        resetState(_state, _action) {
            return initialState;
        },
        updateActiveSection(state, action) {
            return {
                ...state,
                activeSection: action.payload.sectionId,
            };
        },
        updateSectionStatus(state, action) {
            return {
                ...state,
                sections: {
                    ...state.sections,
                    [action.payload.sectionId]: {
                        ...state.sections[action.payload.sectionId],
                        ...action.payload.sectionStatus,
                    },
                },
            };
        },
    },
});

export const { resetState, updateActiveSection, updateSectionStatus } =
    referralChecklistSlice.actions;

export const resetForm = () => (dispatch) => {
    dispatch(resetState());
};

export const setActiveSection = (step) => (dispatch) => {
    dispatch(
        updateActiveSection({
            sectionId: step,
        }),
    );
};

export const completeSection = (step) => (dispatch) => {
    const payload = {
        sectionId: step,
        sectionStatus: { progressIndicatorStatus: FormAccordion.statuses.COMPLETED },
    };
    dispatch(updateSectionStatus(payload));
};

export const enableSection = (step) => (dispatch) => {
    const payload = {
        sectionId: step,
        sectionStatus: { progressIndicatorStatus: FormAccordion.statuses.ACTIVE },
    };
    dispatch(updateSectionStatus(payload));
};

export const disableSection = (step) => (dispatch) => {
    const payload = {
        sectionId: step,
        sectionStatus: {
            isOpen: false,
            progressIndicatorStatus: FormAccordion.statuses.NOT_STARTED,
        },
    };
    dispatch(updateSectionStatus(payload));
};

export const openSection = (step) => (dispatch) => {
    const payload = {
        sectionId: step,
        sectionStatus: { isOpen: true },
    };
    dispatch(updateSectionStatus(payload));
};

export const closeSection = (step) => (dispatch) => {
    const payload = {
        sectionId: step,
        sectionStatus: { isOpen: false },
    };
    dispatch(updateSectionStatus(payload));
};
